module.exports = __webpack_public_path__ + "media/packs/images/flags/JP-5eecb9ea8cbb83b091f10f4909f5534b.svg";